// extracted by mini-css-extract-plugin
module.exports = {"whatsapp_wrapper":"WhatsAppButton_whatsapp_wrapper__2ArhQ","whatsapp_btn":"WhatsAppButton_whatsapp_btn__3HaeW","whatsapp_icon":"WhatsAppButton_whatsapp_icon__3lm3F"};